<template>
  <div class="partners-list">
    <div class="partners-list__item partners-list__item_head hover_green">
      <div class="partners-list__id">#</div>
      <div class="partners-list__name">{{ $t("listsHeader.full_name") }}</div>
      <div class="partners-list__service">{{ $t("listsHeader.service") }}</div>
      <div class="partners-list__phone">{{ $t("listsHeader.phone") }}</div>
      <div class="partners-list__email">{{ $t("listsHeader.email") }}</div>
      <div class="partners-list__masters">
        {{ $t("listsHeader.masterCount") }}
      </div>
      <div class="partners-list__orders">
        {{ $t("listsHeader.orderCount") }}
      </div>
      <div class="partners-list__actions">{{ $t("listsHeader.actions") }}</div>
    </div>

    <transition-group name="list" tag="div" class="partners-list__body">
      <div
        class="partners-list__item hover_green"
        v-for="(item, index) in partners"
        :key="item.id"
        :class="{
          delete: item.deletion_tag,
        }"
      >
        <div class="partners-list__id">{{ index + 1 }}</div>
        <div class="partners-list__name">{{ item.name }}</div>
        <div class="partners-list__service">
          <img
            v-for="service in item.services"
            :key="service.id"
            width="35px"
            height="35px"
            :src="service.icon"
            alt=""
          />
        </div>

        <div class="partners-list__phone">{{ item.phone }}</div>
        <div class="partners-list__email">{{ item.email }}</div>
        <div class="partners-list__masters">{{ item.qty_masters }}</div>
        <div class="partners-list__orders">{{ item.qty_requests }}</div>
        <div class="partners-list__actions">
          <div v-if="$guard('write', 'Partners')" @click="open(item.id)">
            <svg width="28px" height="28px" class="icon">
              <use xlink:href="/images/svg/symbols.svg#svg-user-message"></use>
            </svg>
          </div>
          <div @click="openDeleteModal(item)">
            <svg width="28px" height="28px" class="icon">
              <use xlink:href="/images/svg/symbols.svg#svg-user-del"></use>
            </svg>
          </div>

          <delete-request
            v-if="$guard('delete', 'Administrators') && item.deletion_tag"
            :item="item"
            :type="'partners'"
            @save="getPartners"
            @remove="openDeleteModalAdapter"
          />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import deleteRequest from '@/components/controls/deleteRequest'

export default {
    name: 'partners-list',
    components: {
        deleteRequest,
    },
    computed: {
        ...mapGetters({
            partners: 'partners/partnersGetters',
        }),
    },
    methods: {
        ...mapActions({
            open: 'partners/edit',
            fetch: 'partners/fetch',
        }),
        ...mapMutations({
            toggleDeleteModal: 'partners/setDeleteModal',
            setDeletedId: 'partners/setDeletedId',
            setDeletionStatus: 'partners/setDeletionStatus',
        }),
        openDeleteModalAdapter(id) {
            this.openDeleteModal({
                id,
                deletion_tag: false,
            })
        },
        openDeleteModal({ id, deletion_tag }) {
            this.toggleDeleteModal()
            this.setDeletionStatus(deletion_tag)
            this.setDeletedId(id)
        },
        getPartners() {
            this.fetch({})
        },
    },
}
</script>

<style lang="scss" scoped>
.partners-list {
  width: 100%;
  margin-right: 10px;
  background-color: #fff;
  height: calc(100vh - 241px);

  &__item {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 8.7px 0;

    &_head {
      font-family: "SFUIDisplay-Bold";
      font-size: 16px;
      color: #4d4d4d;
    }
  }

  &__actions {
    display: flex;

    svg {
      cursor: pointer;
      margin-right: 5px;
      transition: transform 0.5s;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  &__id {
    width: 64px;
    height: 100%;
    font-family: "SFUIDisplay-Light";
    font-size: 30px;
    color: #e0e0e0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__name {
    width: 10%;
  }

  &__service {
    width: 7%;
    text-align: center;
  }

  &__phone {
    width: 8%;
  }

  &__email {
    width: 10%;
  }

  &__masters {
    width: 14%;
  }

  &__orders {
    width: 14%;
  }
}
</style>
